import React, {useState} from "../_snowpack/pkg/react.js";
import App from "../components/app.js";
import MainSideBarContainer, {
  SidebarToggleButton
} from "../components/main-sidebar-container.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {Title} from "../components/typo.js";
import {
  getFormattedroductName,
  getTranslatedName,
  getTranslatedSlug,
  withAttrs
} from "../common/utils.js";
import Stack from "../components/stack.js";
import {colors, fontFamily, media} from "../components/theme.js";
import {t} from "../common/i18n.js";
import {ArrowRight} from "../components/icons.js";
import ContentModules from "../components/content-modules.js";
import Image from "../components/image.js";
import SVG from "../_snowpack/pkg/react-inlinesvg.js";
import {getUrl} from "../common/universal.js";
import {Routes} from "../typings/routes.js";
export default function Page(props) {
  const [hoveredProduct, setHoveredProduct] = useState();
  const onProductHover = (p) => {
    setHoveredProduct(p);
  };
  const onProductClick = (p) => navigateToProductPage(p?.page.slug);
  return /* @__PURE__ */ React.createElement(App, {
    ...props
  }, /* @__PURE__ */ React.createElement(Container, {
    title: /* @__PURE__ */ React.createElement(Headline, null, getTranslatedName(props)),
    main: /* @__PURE__ */ React.createElement(Main, {
      ...props,
      hoveredProduct,
      onProductHover,
      onProductClick
    }),
    sidebar: /* @__PURE__ */ React.createElement(Sidebar, {
      onProductHover,
      hoveredProduct,
      ...props
    })
  }));
}
function Main(props) {
  return /* @__PURE__ */ React.createElement(MainContainer, null, /* @__PURE__ */ React.createElement(MainHero, {
    ...props
  }), /* @__PURE__ */ React.createElement(SidebarToggleButton, null, t("Größe auswählen")), props.content.modules && /* @__PURE__ */ React.createElement(ContentModules, {
    modules: props.content.modules,
    isProductPage: true
  }));
}
function MainHero(props) {
  const {content, products, hoveredProduct, onProductHover, onProductClick} = props;
  const {color} = content;
  const image = hoveredProduct ? hoveredProduct.page.content.hover_image : content.group_image;
  const maskImageUrl = content.mask_image?.filename.replace("a.storyblok", "s3.amazonaws.com/a.storyblok") || null;
  const onProductHoverWithId = (id) => {
    const product = products.find((p) => {
      return p.page.slug === id;
    });
    onProductHover && onProductHover(product);
  };
  const onProductClickWithId = (id) => {
    const product = products.find((p) => {
      return p.page.slug === id;
    });
    if (!product)
      return;
    onProductClick && onProductClick(product);
  };
  return /* @__PURE__ */ React.createElement(MainHeroContainer, {
    style: {"--background-color": color.color}
  }, /* @__PURE__ */ React.createElement(Image, {
    ...image,
    sizes: [800, 500]
  }), maskImageUrl && /* @__PURE__ */ React.createElement(HoverSVG, {
    svg: maskImageUrl,
    onProductHover: onProductHoverWithId,
    onProductClick: onProductClickWithId
  }));
}
function Sidebar(props) {
  const {products, onProductHover, hoveredProduct} = props;
  return /* @__PURE__ */ React.createElement(SidebarContainer, null, /* @__PURE__ */ React.createElement(SidebarSections, null, /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, t("Größe auswählen"))), /* @__PURE__ */ React.createElement(SidebarSection, null, /* @__PURE__ */ React.createElement(ProductList, {
    products,
    onProductHover,
    hoveredProduct
  }))));
}
function ProductList(props) {
  const {products, onProductHover, hoveredProduct} = props;
  return /* @__PURE__ */ React.createElement(ListContainer, null, products.map((p) => {
    return /* @__PURE__ */ React.createElement(Product, {
      key: p.page.id,
      ...p,
      active: p === hoveredProduct,
      onMouseEnter: () => onProductHover(p),
      onMouseLeave: () => onProductHover()
    });
  }));
}
function HoverSVG(props) {
  const {svg, onProductHover, onProductClick} = props;
  const onHover = (e) => {
    if (e.target.tagName !== "polygon")
      return onProductHover();
    const {id} = e.target;
    onProductHover(id);
  };
  const onClick = (e) => {
    if (e.target.tagName !== "polygon")
      return;
    const {id} = e.target;
    onProductClick(id);
  };
  const onMouseLeave = () => onProductHover();
  return /* @__PURE__ */ React.createElement(MaskSVG, {
    src: svg,
    onMouseOver: onHover,
    onMouseLeave,
    onClick
  });
}
function Product(props) {
  const {articles, page, active, ...rest} = props;
  if (articles.length === 0)
    return null;
  const [mainArticle] = articles;
  const [product] = page.content.product;
  const isVariableProduct = product.component === "variable_product";
  const href = getUrl(Routes.product, {slug: getTranslatedSlug(page)});
  const dimension = isVariableProduct ? t("Erstelle dein Wunschformat") : mainArticle.cf_inner_dimensions;
  return /* @__PURE__ */ React.createElement(ProductContainer, {
    active,
    href,
    ...rest
  }, /* @__PURE__ */ React.createElement(ProductContainerInner, null, getFormattedroductName(props), /* @__PURE__ */ React.createElement(ArrowIcon, null)), dimension && /* @__PURE__ */ React.createElement(ProductDimension, null, dimension));
}
function navigateToProductPage(slug) {
  location.pathname = `/product/${slug}`;
}
const Container = styled(MainSideBarContainer)``;
const MainContainer = styled(Stack)``;
const MainHeroContainer = styled.div`
  position: relative;
  background-color: var(--background-color);
  width: 100%;
  padding-top: 50%;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 35px;

  img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    min-width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${media.mobile} {
    margin-top: 0;
  }
`;
const SidebarContainer = styled.div``;
const Headline = styled(withAttrs(Title, {level: 2}))`
  font-size: 30px;
`;
const SectionHeadline = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: 700;
  text-transform: uppercase;
  font-size: 14px;
`;
const SidebarSections = styled.div``;
const SidebarSection = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid ${colors.b6};

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
`;
const ListContainer = styled.div`
  font-family: ${fontFamily.secondary};
  font-size: 14px;
`;
const ArrowIcon = styled(ArrowRight)`
  margin-left: 6px;
  opacity: 0;
  transform: translateX(-5px) rotate(180deg);
  transition: opacity 0.2s ease, transform 0.2s ease;
`;
const ProductContainer = styled.a`
  cursor: pointer;
  color: ${colors.b};
  text-decoration: none;

  ${({active}) => active && `
    & > div {
      color: ${colors.c};

      svg {
      opacity: 1;
      transform: translateX(0) rotate(180deg);
      transition: opacity 0.1s ease, transform 0.2s ease;

      path {
        stroke: ${colors.c};
      }
    }
`}
`;
const ProductContainerInner = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  padding: 8px 0 4px;
`;
const ProductDimension = styled.span`
  color: ${colors.b2};
  font-size: 12px;
  padding-bottom: 8px;
  display: block;
`;
const MaskSVG = styled(SVG)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  polygon {
    cursor: pointer;
    fill: transparent;
  }
`;
